// @flow strict

import * as React from 'react';
import classnames from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import type { Layout } from '../types';
import ResponsiveImage from '../ResponsiveImage';

type PropTypes = {|
  id?: string,
  background:
    | 'Default'
    | 'DefaultContrast'
    | 'Featured'
    | 'FeaturedContrast'
    | 'Dark'
    | 'Silver'
    | 'Crystal'
    | 'Charcoal'
    | 'White'
    | 'None'
    | 'NoMargin',
  removePadding: boolean,
  removeMargin: boolean,
  compact?: boolean,
  smallPadding?: boolean,
  layout: Layout,
  image?: string,
  children?: React.Node,
  className?: string,
  title?: string,
  intro?: string,
|};

const PageContentBlock = (props: PropTypes) => {
  const classes = classnames(
    styles.pageContentBlock,
    styles[`is${props.background}`],
    props.image && styles.hasImage,
    props.image && props.background === 'Dark' && styles.isDarkImage,
    props.layout === 'Thin' && styles.isThin,
    props.removePadding && styles.noPadding,
    props.removeMargin && styles.noMargin,
    props.layout === 'Full' && styles.isFull,
    props.compact && styles.compact,
    props.smallPadding && styles.smallPadding,
    props.className,
  );

  const imageClasses = classnames(styles.image, props.background === 'Dark' && styles.imageThin);
  return (
    <div className={classes} id={props.id}>
      {props.image && (
        <ResponsiveImage
          className={imageClasses}
          src={props.image}
          alt=""
          defaultSize={{ width: 1000 }}
          srcSet={[
            { mediaMaxWidth: 750, width: 750 },
            { mediaMaxWidth: 600, width: 600 },
            { mediaMaxWidth: 400, width: 400 },
          ]}
        />
      )}
      {props.title && <h2 className={styles.title}>{props.title}</h2>}
      {props.intro && <p className={styles.intro}>{props.intro}</p>}
      {props.children}
    </div>
  );
};

PageContentBlock.defaultProps = {
  background: 'Default',
  layout: 'Default',
  removePadding: false,
  removeMargin: false,
};

export default PageContentBlock;
